module.exports = __webpack_public_path__ + "img/weatheryours.9eace3b3.jpg";